import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import * as L from 'leaflet';
import {LayerGroup} from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class MapLayersService {
  refreshLayers = new BehaviorSubject<number>(0);
  chosenLeafletGeoLayers: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);
  leafletRegionsAll: BehaviorSubject<L.Layer[]> = new BehaviorSubject([]);
  leafletSumOfGeofences: BehaviorSubject<L.Layer[]> = new BehaviorSubject([]);
  leafletGeofencesTechWorkArea: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);
  leafletGeofencesRideAllow: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);
  leafletGeofencesRideRestrict: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);
  leafletGeofencesFinishAllow: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);
  leafletGeofencesFinishRestrict: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);
  leafletGeofencesSpeedLimit: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);
  leafletGeofencesDemand: BehaviorSubject<L.Layer[]> = new BehaviorSubject<L.Layer[]>([]);

  geopointPane: BehaviorSubject<HTMLElement> = new BehaviorSubject<HTMLElement>(null);
  geopointLayersGroup: BehaviorSubject<LayerGroup> = new BehaviorSubject<LayerGroup>(null);

  controlGeoObjectsVisibility: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  geoitemVisibility: BehaviorSubject<{ [i: string]: boolean }> = new BehaviorSubject<{ [i: string]: boolean }>({
    regions: false,
    geopoints: false,
    ride_allow: false,
    ride_restrict: false,
    finish_allow: false,
    finish_restrict: false,
    speed_limit: false,
    tech_work_area: false,
    demand: false,
  });

  constructor() {
  }

  emitRefreshLayers(): void {
    this.refreshLayers.next(Date.now());
  }

  deleteAllLayers() {
    this.chosenLeafletGeoLayers.next([]);
    this.leafletRegionsAll.next([]);
    this.leafletSumOfGeofences.next([]);
    this.leafletGeofencesTechWorkArea.next([]);
    this.leafletGeofencesRideAllow.next([]);
    this.leafletGeofencesRideRestrict.next([]);
    this.leafletGeofencesFinishAllow.next([]);
    this.leafletGeofencesFinishRestrict.next([]);
    this.leafletGeofencesSpeedLimit.next([]);
    this.leafletGeofencesDemand.next([]);
    this.geopointLayersGroup.next(null);
  }
}
